import { render, staticRenderFns } from "./AdminSideDrawer.vue?vue&type=template&id=54647bb3&"
import script from "./AdminSideDrawer.vue?vue&type=script&lang=ts&"
export * from "./AdminSideDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports